module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"expand_review":"Show more","collapse_review":"Show less"}}')
  delete Component.options._Ctor
}
